import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-icon-selector',
  templateUrl: './icon-selector.component.html',
  styleUrls: ['./icon-selector.component.css']
})
export class IconSelectorComponent implements OnInit {
  @Input('icon') icon: string;
  @Output('iconChange') iconChange = new EventEmitter<string>();

  availableIcons = [
    "fas fa-phone-office",
    "far fa-building",
    "fas fa-at",
    "fas fa-eye",
    "fas fa-headset",
    "fas fa-asterisk",
    "fas fa-snowman",
    "fas fa-shopping-cart",
    "fab fa-linkedin",
    "fab fa-instagram",
    "fas fa-cocktail",
    "fas fa-phone-volume",
    "fas fa-american-sign-language-interpreting",
    "fab fa-facebook",
    "far fa-id-card",
    "fas fa-poo",
    "fas fa-search-dollar",
    'fa-solid fa-alarm-plus',
    'fa-solid fa-address-book',
    'fa-solid fa-alicorn',
    'fa-solid fa-award',
    'fa-solid fa-bacon',
    'fa-solid fa-badge-check',
    'fa-solid fa-bank',
    'fa-solid fa-barcode',
    'fa-solid fa-bed-empty',
    'fa-solid fa-bird',
    'fa-solid fa-bluetooth',
    'fa-solid fa-bicycle',
    'fa-solid fa-bong',
    'fa-solid fa-bone',
    'fa-solid fa-book-section',
    'fa-solid fa-box-circle-check',
    'fa-solid fa-bullhorn',
    'fa-solid fa-calendar-days',
    'fa-solid fa-calculator',
    'fa-solid fa-camera-cctv',
    'fa-solid fa-camera-polaroid',
    'fa-solid fa-camera-rotate',
    "fa-brands fa-google"
  ];

  constructor() { }

  ngOnInit() {
  }

  selectIcon(x) {
    this.iconChange.emit(x) 
  }

}

export class AvailableIcons {

}
